export default {
    active: true,
    seed: 5,
    skyType: "gradient",
    skyColor: "#23a06b",
    horizonColor: "#f5e170",
    lighting: "distant",
    lightPosition: { x: 0.5, y: 1, z: 0 },
    fog: 0.8,
    flatShading: false,
    playArea: 1,
    ground: "spikes",
    groundYScale: 4.26,
    groundTexture: "walkernoise",
    groundColor: "#273a49",
    groundColor2: "#2b464f",
    dressing: "towers",
    dressingAmount: 3,
    dressingColor: "#5f6d94",
    dressingScale: 50,
    dressingVariance: { x: 10, y: 100, z: 10 },
    dressingUniformScale: true,
    dressingOnPlayArea: 0,
    grid: "none",
    gridColor: "#239893",
    shadow: false,
};
